import {useState} from "react";
import {Modal} from "../Modal.jsx";

export const NewsroomResult = (props) => {
    const [showModal,setShowModal] = useState(false)

    const getTeaser = () => {
        const teaser = <div className="text" dangerouslySetInnerHTML={{__html: props.result.teaser}}/>

        if (props.result.locked) {
            return teaser
        }

        return <>{teaser}</>
    }

    const onClick = (e) => {
        if (showModal) {
            return
        }
        e.preventDefault()
        setShowModal(true)
    }

    return (
        <a href={props.result.url} title={props.result.title} onClick={props.result.locked ? onClick : undefined} className={"um-sheet" + (props.result.image !== '' ? ' um-sheet--image' : '') + (props.result.stickyNews ? ' bg-primary' : ' bg-grey') + (props.result.locked ? ' article--locked' : '')}>
                {props.result.image !== '' && <div className="image">
                    <img src={props.result.image} alt={props.result.title}
                         style={{objectFit: 'cover', width: '100%', height: '100%'}}/>
                </div>}
                <div className="content">
                    <div className="info">
                        {props.result.publishedAt}
                        <span className="news-list-category"> | {props.result.category}</span>
                    </div>
                    <div className="headline_3">
                        {props.result.title}
                    </div>

                    <div className="text">
                        {getTeaser()}
                    </div>

                    <div className="bottom">
                        <div className="news-list-tags">
                            {props.result.tags.map(tag =>
                                <span>{tag}</span>
                            )}
                        </div>
                        <div>
                            {props.result.readingTime !== '' ?
                                <span dangerouslySetInnerHTML={{__html: props.result.readingTime}}/> : ''}
                        </div>
                    </div>
                </div>
            {(showModal) &&
                <Modal userRoles={props.result.userRoles} setShowModal={setShowModal} loginUrl={props.result.loginUrl}></Modal>
            }
        </a>
    )
}
